export default {
  home: {
    openFinance: 'Open Finance',
    description:
      'Secure, fast, gas-free on-chain trading with institutional liquidity',

    gasFees: 'Gas Fees',
    whyHelix: 'Why Helix?',
    reimagined: 'Reimagined',
    latestNews: 'Latest News',
    totalVolume: 'Total Volume',
    totalMarkets: 'Total Markets',
    startTrading: 'Start Trading',
    helixDocs: 'Helix Documentation',
    somethingIsBrewing: 'Something is brewing',
    builtForTheCommunity: 'Built for the Community',
    builtForTheCommunityDescription: 'No investors, no VCs, no nonsense.',
    downloadHelixMobile: 'Download the Helix Mobile app for iOS or Android',

    overview: {
      title: 'Why Helix?',
      lpRewardsTitle: 'LP Rewards',
      tradingBotsTitle: 'Trading Bots',
      gasFreeTitle: 'Gas Free Trading',
      tradeStocksTitle: 'Trade Stocks and RWAs',
      lpRewardsDescription: 'Provide liquidity and get paid for it.',
      description: 'Built as top-tier exchange, but fully decentralized.',
      gasFreeDescription:
        'Never worry about gas fees on Helix. Zero gas, always.',
      tradingBotsDescription:
        'Deploy advanced smart on-chain trading strategies in just a click.',
      tradeStocksDescription:
        'Trade stocks and Real World Assets (RWAs) with crypto for faster, cheaper, and more transparent transactions.'
    },

    gettingStarted: {
      title: 'Getting started on Helix',
      injectiveBridge: 'Injective Bridge',
      description: 'Deposit crypto assets to Injective ',
      description2:
        'Bridge USDT and other assets into Helix via the {bridgeLink}.',
      gasRequirement:
        'Make sure you get at least 0.1 INJ to pay for the transaction fee.',
      step1: {
        title: 'Step 1',
        description: 'Visit the Injective Bridge and connect your wallet.'
      },
      step2: {
        title: 'Step 2',
        description:
          'Select the source chain (e.g. Ethereum, Cosmos or Solana).'
      },
      step3: {
        title: 'Step 3',
        description: 'Choose USDT or any other asset'
      },
      step4: {
        title: 'Step 4',
        description:
          'Once complete, return to Helix and check your Balances on the Portfolio page. You are ready to trade!'
      }
    },

    mobile: {
      usp1: 'Beginner Friendly',
      title: 'Trade Perps from Your Pocket',
      usp2: 'Crypto, Stocks, Commodities, and FX',
      downloadHelixMobile: 'Download Helix Mobile'
    },

    faq: {
      title: 'Frequently Asked Questions',

      accordion1: {
        title: 'What features does Helix offer?',
        featureTitle:
          'Helix offers a seamless and powerful trading experience with advanced features and flexibility:',

        stocks: 'stocks',
        lpRewards: 'LP rewards',
        commodities: 'commodities',
        spotMarkets: 'Spot Markets',
        tradingBots: 'trading bots',
        autoSigning: 'auto-signing',
        makerRebates: 'maker rebates',
        feeDiscounts: 'fee discounts',
        oneHundredLeverage: '100x leverage',
        perpetualMarkets: 'Perpetual Markets',
        tradingCompetitions: 'trading competitions',

        feature1: 'Trade top crypto pairs on {spotMarkets}',
        feature2:
          'Use up to {oneHundredLeverage} on {perpetualMarkets}, including crypto, {stocks}, and {commodities} like gold and silver.',
        feature3:
          'Automate your strategies with built-in {tradingBots} for spot and perpetual markets.',
        feature4:
          'Earn through {lpRewards}, {makerRebates}, and {feeDiscounts} by staking INJ.',
        feature5:
          'Benefit from a smooth trading flow with {autoSigning} and a gas-free experience.',
        feature6:
          'Participate in frequent {tradingCompetitions} and unlock exclusive rewards.'
      },

      accordion2: {
        title: 'How do I get assets onto Helix?',
        optionTitle:
          'To start trading on Helix, you’ll first need to get assets like USDT or INJ on Injective:',

        fiatOnRamps: 'fiat on-ramps',
        injectiveBridge: 'Injective Bridge',

        option1:
          'Buy crypto via {fiatOnRamps} (through debit/credit cards, Revolut, Apple Pay, Google Pay & more).',
        option2: 'Use {injectiveBridge} to deposit assets from other chains.',
        option3:
          'Alternatively, you can also deposit from different centralized exchanges like Binance, ByBit & more.'
      },

      accordion3: {
        title: 'How do I trade cryptocurrencies on Helix?',
        stepTitle:
          "Trading on Helix is fast, permissionless, and completely gas-free. Here's how to get started:",

        inj: 'INJ',
        spot: 'Spot',
        usdt: 'USDT',
        limit: 'limit',
        helix: 'helixapp.com',
        perpetual: 'Perpetual',
        marketOrder: 'market order',
        videoTutorialHere: 'video tutorial here',

        step1: 'Head to {helix} and connect your wallet.',
        step2: 'Deposit or bridge assets like {usdt} or {inj}.',
        step3: 'Pick a {spot} or {perpetual} market you want to trade.',
        step4: 'Place a {limit} or {marketOrder} with just a few clicks.',
        cta: 'Want a full walkthrough? Check out our step-by-step {tutorial}.'
      },

      accordion4: {
        appStore: 'iOS (App Store)',
        playStore: 'Android (Google Play)',
        title: 'Is there a Helix Mobile app, and where can I get it?',
        description:
          'Helix Mobile is free on {appStore} and {playStore}. Install the app, connect your wallet, and you’ll see the same markets and balances you see on the web version.'
      },

      accordion5: {
        description: 'You have three options:',
        title: 'How do I connect my wallet on Helix Mobile?',

        option1:
          'Scan a QR code - open Helix Mobile, tap “Scan QR code on Helix web,” and point your camera at the QR code shown on the Helix web app in settings. (link to AuthZ module in ACM)',
        option2:
          'Use your existing social login - sign in with the same Google or Apple account you use on desktop and your wallet appears instantly.',
        option3:
          'Create a brand-new wallet - generate a fresh non-custodial wallet tied to your email if you’d like to start from scratch.'
      },

      accordion6: {
        title: ' How does Helix Mobile keep my assets secure?',
        description:
          'The Helix Mobile app is fully non-custodial. Private keys stay on your device, transactions are signed locally, and you can add biometric two-factor verification in settings. Helix never holds your funds or seed phrase - security works exactly as it does on the web. For social login, keys are securely stored by Turnkey, the industry standard for key management.'
      }
    }
  }
}
